{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowSingleRightIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowSingleRightIcon = React.forwardRef<SVGSVGElement, ArrowSingleRightIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 61 91"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M50.4346 45.4919C44.987 41.1817 40.1398 37.3172 35.2626 33.4855C27.2756 27.2103 19.1692 21.0806 11.3247 14.6347C8.05416 11.9437 5.30221 8.62145 2.3651 5.53797C1.10427 4.21414 0.00225389 2.50952 1.49805 0.913964C3.15793 -0.858149 4.96936 0.25769 6.35488 1.636C21.2597 16.4653 39.7113 26.6458 56.0863 39.5501C60.9117 43.3529 61.5404 46.5544 57.4547 51.2597C56.19 52.7677 54.8172 54.1815 53.3468 55.4898C42.6584 64.6667 32.0394 73.9329 21.1403 82.8538C17.6407 85.7181 13.3954 87.6905 9.40551 89.9187C8.72554 90.2987 6.9344 90.1445 6.82807 89.8354C6.43427 88.6973 6.00249 87.0334 6.55054 86.2097C8.70464 82.9667 10.8522 79.5598 13.6876 76.9607C20.5305 70.6887 27.7726 64.8532 34.8263 58.809C38.9743 55.2543 43.0627 51.6292 47.1936 48.0535C48.0974 47.2711 49.0701 46.5657 50.4346 45.4919Z" fill={color}/>

      </svg>
    )
  }
)

ArrowSingleRightIcon.displayName = 'ArrowSingleRightIcon'
